import React, { useState } from "react";
import { observer } from "mobx-react";
import { Grid2 } from "@mui/material";
import { useStores } from "../../../use-stores";
import { EmployeeRoles } from "../../../../../models/Employees/EmployeeRoles";
import PermissionBlockLabel from "../../../../../views/components/common/pop-up/PermissionBlockLabel ";
import LoaderOverlay from "../../../../../views/components/common/pages/AppLoader";
import { RedemptionDashboardStore } from "../../../stores/dashboards/RedemptionDashboardStore";
import RedemptionFilters from "../../components/dashboard/redemption/RedemptionFilters";
import RedemptionJourney from "../../components/dashboard/redemption/RedemptionJourney";
import RedemptionProductsTable from "../../components/dashboard/redemption/RedemptionProductsTable";
import RedemptionConsumption from "../../components/dashboard/redemption/RedemptionConsumption";
import RedemptionDrawer from "../../components/dashboard/redemption/RedemptionDrawer";

const RedemptionDashboardView: React.FC = observer(() => {
  const [store] = useState(() => new RedemptionDashboardStore());

  return (
    <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12 }} sx={{ px: 2, pb: 4 }}>
      <LoaderOverlay loading={store.summaryLoading} />
      <RedemptionFilters store={store} />
      <RedemptionJourney store={store} />
      <RedemptionProductsTable store={store} />
      <RedemptionConsumption store={store} />
      <RedemptionDrawer store={store} />
    </Grid2>
  );
});

const RedemptionDashboard: React.FC = () => {
  const { userStore } = useStores();

  if (!userStore.hasPermission(EmployeeRoles.VIEW_REDEMPTION_DASHBOARD)) {
    return <PermissionBlockLabel />;
  }

  return <RedemptionDashboardView />;
};

export default observer(RedemptionDashboard);
